import { render, staticRenderFns } from "./detailstations.vue?vue&type=template&id=2a4a7190"
import script from "./detailstations.vue?vue&type=script&lang=js"
export * from "./detailstations.vue?vue&type=script&lang=js"
import style0 from "./detailstations.vue?vue&type=style&index=0&id=2a4a7190&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports